module.exports = __webpack_public_path__ + "b0d040b73ca50d8269c1abbbdf6bf0d4.svg";